import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;

  width: 100%;
  flex-wrap: wrap;
`;
